import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-share-certificate',
  templateUrl: './share-certificate.component.html',
  styleUrls: ['./share-certificate.component.scss'],
})
export class ShareCertificateComponent {
  environment: string;
  contactId: string;
  certificateLevel: string;
  shareCertificateUrl: string;

  constructor(public activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// ./ts/app/progress/share-certificate/share-certificate.component.ts